import PropTypes from "prop-types";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

import styled from "styled-components/macro";

import useGroupOrSignupID from "Boards/useGroupOrSignupID";

import { FnrPopover } from "UI/FnrPopover2";
import { colors } from "UI/colors";

import { cellContainerStyles, editableCellStyles } from "./cellContainerStyles";

SignupItemsCell.propTypes = {
  rawValue: PropTypes.string,
  value: PropTypes.string,
};

export default function SignupItemsCell({ value, rawValue }) {
  const popoverTriggerRef = useRef();
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  // Warning: this will definitely break outside /signups boards :)
  const { signupListID } = useGroupOrSignupID();
  let didParse = false;
  let values;

  try {
    if (typeof rawValue === "string") {
      values = JSON.parse(rawValue).values;
      didParse = true;
    }
  } catch (e) {
    console.error(e);
  }

  if (!(typeof signupListID === "number" && didParse && Array.isArray(values)))
    return <Container title={value}>{value}</Container>;

  return (
    <>
      <Trigger
        ref={popoverTriggerRef}
        onClick={() => {
          setIsPopoverOpen((prev) => !prev);
        }}
        title={value}
      >
        {value}
      </Trigger>
      <FnrPopover
        buttonRef={popoverTriggerRef}
        show={isPopoverOpen}
        onShouldClose={() => setIsPopoverOpen(false)}
      >
        <ItemsList>
          {values.map(({ signupItemID, itemTitle }, idx) => (
            <Item key={signupItemID}>
              <div>{itemTitle}</div>
              <ItemLink
                to={`/signups/${signupListID}/items/${signupItemID}/respondents`}
                style={{ textDecoration: "underline" }}
                onClick={() => {
                  setIsPopoverOpen(false);
                }}
              >
                All&nbsp;Respondents
              </ItemLink>
            </Item>
          ))}
        </ItemsList>
      </FnrPopover>
    </>
  );
}

const Container = styled.div`
  ${cellContainerStyles};
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Trigger = styled.button`
  ${cellContainerStyles};
  ${editableCellStyles};

  &:hover {
    cursor: pointer;
  }

  overflow: hidden;
  text-overflow: ellipsis;
`;

const ItemsList = styled.ul`
  /* BEGIN reset */
  list-style-type: none;
  margin-block-start: 0;
  margin-block-end: 0;
  padding-inline-start: 0;
  /* END reset */

  padding: 0.3rem;
  max-width: 320px;
`;

const Item = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.4rem 0;

  &:not(:first-child) {
    border-top: 1px solid ${colors.fnGray600};
  }
`;

const ItemLink = styled(Link)`
  font-size: 14px;
  margin-left: 1rem;
`;
